import barba from '@barba/core';
import { gsap } from 'gsap';
import { disableScroll, enableScroll } from '../helper/scroll';
import * as common from '../common';
import { power5 } from '../helper/easing';
power5();

const debug = false;

const pageTransitions = {
	init() {

        const header = document.querySelector('.k-header');
        const headerInner = document.querySelector('.k-header-inner');
        const burgerMenu = document.querySelector('.k-header .js-nav-burger');

        const featuredReset = async (target) => {
            const obj = target;            
            const imgInner = target.querySelector('.js-featured-project-img-inner');
            const img = target.querySelector('.js-featured-project-img');
            const blocker = document.querySelector('.js-event-blocker');
            const prepT = 0.4;
            const start = 0.3;
            
            return gsap.timeline()
            .set(blocker, {'display': 'block'})
            .set(blocker, {'z-index': '1000'})
            .set(obj, {'pointer-events': 'none'})
            .to(obj, prepT, {
              x: 0,
              y: 0,
              scale: 1,
              ease: "power1.inOut",
              overwrite: true
            }, start)
            .to( imgInner, prepT, {
                x: 0,
                y: 0,
                scale: 1,
                ease: "power1.inOut",
                overwrite: true
            }, start)  
            .to( img.querySelector('img'), prepT, {
                opacity: 1,
                ease: "power1.inOut",
                overwrite: true
            }, start)                        
            .to( img, prepT, {
                x: 0,
                y: 0,
                opacity: 1,
                ease: "power1",
            }, start)            
            // .to( vid, prepT, {
            //     opacity: 0,
            //     ease: "power1",
            // }, 0)
            // .set(imgInner, {clearProps: 'transform'}, prepT*1.2)
            ;
        };

        const updateBodyClasses = () => {
            let bodyClasses = document.getElementById('k-content').dataset.bodyclasses;
            document.querySelector('body').className = bodyClasses;
		}
        const updateHeaderColour = async () => {
            document.querySelector('.k-header').classList.remove('text-dark');
            document.querySelector('.k-header').classList.remove('dark');
            let darkHero = document.querySelectorAll('[data-herodarktext]');
            if (darkHero.length > 0) {
                document.querySelector('.k-header').classList.add('text-dark');
                document.querySelector('.k-header').classList.add('dark');
            }
		}  
		const onPageLoad = () => {
            updateHeaderColour().then(() =>{
                updateBodyClasses();
                header.classList.remove('barba-transitioning');
                document.querySelector('.k-footer').classList.remove('barba-transitioning');
                // gsap.set(burgerMenu, {x: '100%'}, 0);
                gsap.to(document.querySelectorAll('.icon-burger .h-lines line'), {clearProps: 'all'}, 0);
                gsap.to(document.querySelectorAll('.icon-burger .d-lines line'), {clearProps: 'all'}, 0);
                gsap.to(document.querySelectorAll('.icon-burger-circle path'), {clearProps: 'all'}, 0);
                gsap.to(document.getElementById('cookie-law-info-bar'), 1.4, {opacity: 1, y: '0%', ease: 'power3.inOut', delay: 3});
                // gsap.fromTo(document.querySelector('.k-header'), 1, {opacity: '0'}, {opacity: '1'}, '0.3');
                gsap.to(headerInner, 1.5, {opacity: 1, delay: 1});
                // gsap.to(header, 0.6, {opacity: 1}, 0.5);
                gsap.set(document.querySelector('.js-icon-play'), {opacity: 0});
                common.containerInit(); 
            });
		}
		const beforePageLoad = () => {
			header.classList.add('barba-transitioning');
            header.classList.remove('scrolled');
            gsap.to(headerInner, 0.2, {opacity: 0});
			document.querySelector('.k-footer').classList.add('barba-transitioning');
            gsap.set(document.querySelector('.js-icon-play'), {opacity: 0});
			let vids = document.querySelectorAll('video');
            if (vids.length > 0){    
                vids.forEach(function(vid) {
                    vid.pause();
                });
            }

		}            
        
        const heroSize = () => {

            let
            heroWidth = document.querySelector('html').clientWidth,
            heroHeight = window.innerHeight,
            size = [];

            // if viewport height is 1/2 of viewport width or more and 1280px (xl) wide or more, restrict the height of the hero
            // make sure that these media queries and values match those in projects.scss
            if (((window.innerHeight / window.innerWidth) >= 0.5) && (window.innerWidth >= 1280)) {
                heroHeight = heroWidth / 2;
            }

            // if viewport is portrait 768px (md) or more, make the hero square
            // make sure that these media queries and values match those in projects.scss            
            if ((window.innerWidth <= window.innerHeight) && (window.innerWidth >= 768)) {
                heroHeight = heroWidth;
            }   

            size.push(heroWidth, heroHeight);            
            return size;
        }

		const pageTransFeaturedProject = async(target, done, heroWidth, heroHeight) => {

            const obj = target;
            const container = obj.closest('[data-featuredprojectscontainer]');
            const otherHideme = container.querySelectorAll('.js-featured-project-hideme');
            const otherContainers = document.querySelectorAll(`.section:not([data-featuredprojectscontainer])`);
            const imgContainer = obj.querySelector('.js-featured-project-img');
            const imgInner = obj.querySelector('.js-featured-project-img-inner');
            const img = imgInner.querySelector('img');
            const hideme = obj.querySelectorAll('.js-featured-project-hideme');
            const targetID = target.getAttribute('id');
            const otherProjects = document.querySelectorAll('[data-featuredprojectlink]:not(#'+targetID+')');

            let
            winWidth = document.querySelector('html').clientWidth,
            winHeight = window.innerHeight,            
            cX = (winWidth - imgContainer.offsetWidth) /2,
            cY = (winHeight - imgContainer.offsetHeight) /2,
            mX = cX - imgContainer.getBoundingClientRect().left,
            mY = cY - imgContainer.getBoundingClientRect().top,
            dur1 = 0.7;

            return gsap.timeline()                
            // .set(container, {
            //     'z-index': 500,
            // })            
            .set(document.querySelector('.js-project-archive'), {
                'overflow-x': 'inherit',
            })                        
            .set(otherProjects, {
                'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
            })            
            .set(obj, {
                // pointerEvents: 'none',
                'z-index': 501,
                'overflow': 'visible',
            })
            .set(imgContainer, {
                'overflow': 'hidden',
                'z-index': 502,
            })
            .set('body', {
                'overflow-x': 'hidden',
            })                       
            .to(otherProjects, dur1*0.2, {
                'clip-path': 'polygon(100% 0, 100% 0, 100% 100%, 100% 100%)',
                ease: 'power5.in',
                x: 80,
                scale: 0.8,
                opacity: 0.3,
                ease: 'power4.in',
                stagger: '0.09',
            }, 0)         
            .to(hideme, dur1, {
                opacity: 0,
            }, 0)
            .to(otherHideme, dur1, {
                opacity: 0,
            }, 0)            
            .to(otherContainers, dur1, {
                opacity: 0,
            }, 0)                                                                                              
            .to(imgContainer, dur1, {
                scale: 1,
                ease: 'power4.in',
                height: heroHeight,
                width: heroWidth,
                y: imgContainer.getBoundingClientRect().top*-1,
                x: imgContainer.getBoundingClientRect().left*-1,
                // immediateRender: false
            }, 0)  
            // .to(header, 0.3, {opacity: 0}, 0)
            // // doesn't do anything, just need to onComplete on the last 
            .to(imgContainer, 0, {
                opacity: 1,
                onComplete: () => done(),
            })  
            ;                         

		}

        // For testing featured project animations without project single page load

        // let triggers = document.querySelectorAll('[data-featuredprojectlink]');

        // triggers.forEach(function(trigger) {	
        //     trigger.addEventListener("click", function(event){
        //         event.preventDefault()
        //       });
        //     let data = trigger.dataset.featuredprojectlink;
        //     let t = document.getElementById(data);
        //     pageTransFeaturedProject(t);
        // });

		const pageTransNextProject = (target, done, heroWidth, heroHeight) => {

            let obj = target,
            imgContainer = obj.querySelector('.js-next-project-img'),
            imgInner = obj.querySelector('.js-next-project-img-inner'),
            copy = obj.querySelector('.js-next-project-copy'),
            dur1 = 1;

            return gsap.timeline()         
            .set(obj, {
                'z-index': 500,
                'position': 'relative',
                'overflow': 'visible',
            })
            .set(imgContainer, {
                'overflow': 'hidden',
            })        
            .set('body', {
                'overflow-x': 'hidden',
            })
            .to(copy, dur1*0.3, {
                opacity: 0,
            }, 0)             
            .add('textHidden')
            .to(imgInner, dur1*1.5, {
                scale: 1,
                top: '-10%',
                y: 0,
                ease: 'power2.inOut',
            }, 'textHidden')                                                                        
            .to(imgContainer, dur1, {
                scale: 1,
                ease: 'power4.in',
                height: heroHeight,
                width: heroWidth,
                y: imgContainer.getBoundingClientRect().top*-1,
                x: imgContainer.getBoundingClientRect().left*-1,
            }, 'textHidden')  
            // doesn't do anything, just need to onComplete on the last 
            .to(imgContainer, 0, {
                opacity: 1,
                onComplete: () => done(),
            })  
            ;            

		}    

		const pageTransDefault = (page, done) => {

            const swiper = document.querySelector('.js-page-swiper');
            const duration = 0.6;

            return gsap.timeline() 
            .set(swiper, {transformOrigin: '0% 50%'})        
            .fromTo(swiper, duration, {
                scaleX: 0,
            },
            {
                scaleX: 1,
                ease: 'power4.in',
            }, 0)
            // .set(header, {opacity: 0}, duration)
            .set(burgerMenu, {x: '100%'}, duration)
            .set(page, {opacity: 0}, duration)
            .set(swiper, {transformOrigin: '100% 50%'}, duration)        
            .fromTo(swiper, duration, {
                scaleX: 1,
            },
            {
                scaleX: 0,
                ease: 'power3.out',
                onComplete: () => done(),
            }, duration*2)            
            ;            

		}            
        
        const defaultOncePrep = async () => {
            
            // disableScroll();

            const tl = gsap.timeline();

            const winWidth = document.querySelector('html').clientWidth;
            const winHeight = window.innerHeight;
            const padding = winWidth*0.03;
            
            const logo = document.querySelector('.k-header-inner .logo');
            const burger = document.querySelector('.js-burger');
            const logoWrapper = document.querySelector('.k-header-inner .logo-wrapper');
            const logoRect = logo.getBoundingClientRect();
            // const logoWidth = logoRect.width;
            // const logoHeight = logoRect.height;
            // const logoX = logoRect.left;
            // const logoY = logoRect.top;
            // const logoSvg = logo.querySelector('svg');
            // const bg = window.getComputedStyle( document.body ,null).getPropertyValue('background-color');

            return tl
            .set(document.getElementById('header-logo'), {'pointerEvents': 'none'})
            .set(burger, {opacity: 0}, 0)
            .set(logoWrapper, {
                css: {
                    'padding': padding,
                    'background-color' : 'rgba(0,0,0,1)',
                    'width' : winWidth,
                    'height' : winHeight,
                    'position' : 'absolute',
                    'top' : '0',
                    'left' : '0'
                },                
            }, 0)
            .set(logo, {
                opacity: 0,
                'width' : '100%',
                'height' : '100%',            
            }, 0)            
            .set(logoWrapper, {
                x: (logoRect.left*-1),
                y: (logoRect.top*-1),
            }, 0)
            .set(document.querySelector('.k-header-inner'), {
                opacity: 1,
            }, 0)
            ;
    
        }

		const pageTransDefaultOnce = (logoRect, done, next) => {

            const tl = gsap.timeline();
            const logo = document.querySelector('.k-header-inner .logo');
            const logoWrapper = document.querySelector('.k-header-inner .logo-wrapper');
            const vid = document.querySelector('.k-header-inner .js-intro-video');
            const burger = document.querySelector('.js-burger');
            const duration1 = 0.42;
                       
            if (debug === false ) {

                return tl           
                .fromTo(logo, 0.7, {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    ease: 'power4.in',                    
                }, 0)
                .fromTo(vid, 0.7, {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    ease: 'power4.in',                    
                }, 0)            
                .add('logoVisible')
                .to(logoWrapper, duration1, {
                    x: 0,
                    y: 0,
                    ease: 'expo.inOut',
                    'padding': '0',
                    'height' : logoRect.height+'px',
                }, 'logoVisible+=2')
                .add('logoXY')
                .to(logoWrapper, duration1, {
                    css: {
                        'width' : logoRect.width+'px',
                        // 'height' : logoRect.height+'px',
                    },    
                    ease: 'expo.inOut',                
                }, 'logoXY-=0.15')    
                .add('inPosition')
                .to(logoWrapper, 0.2, {
                    css: {
                        'background': 'rgba(0,0,0,0)',
                    },    
                    ease: 'power1',
                    onComplete: () => done(),
                }, 'inPosition-=0.5')             
                .to(vid, 0.2, {opacity: 0}, 'inPosition-=0.5')
                .fromTo(next, 0.4, {opacity: 0}, {opacity: 1}, 'inPosition')
                .to(burger, 0.4, {opacity: 1}, 'inPosition')
                .set(logoWrapper, {css: {'position' : 'static',}}, 'inPosition')
                .set(logoWrapper, {x: 0, y: 0}, 'inPosition')
                .set(document.getElementById('header-logo'), {'pointer-events': 'auto'}, 'inPosition')
                ;      
 
            } else {
                // debugging timeline - reduces intro logo animation duration to 0s
                return tl           
                .fromTo(logo, 0, {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    ease: 'power4.in',                    
                }, 0)
                .fromTo(vid, 0, {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    ease: 'power4.in',                    
                }, 0)            
                .add('logoVisible')
                .to(logoWrapper, 0, {
                    x: 0,
                    y: 0,
                    ease: 'expo.inOut',
                    'padding': '0',
                    'height' : logoRect.height+'px',
                }, 'logoVisible')
                .add('logoXY')
                .to(logoWrapper, 0, {
                    css: {
                        'width' : logoRect.width+'px',
                        // 'height' : logoRect.height+'px',
                    },    
                    ease: 'expo.inOut',                
                }, 'logoXY')    
                .add('inPosition')
                .to(logoWrapper, 0, {
                    css: {
                        'background': 'transparent',
                    },    
                    ease: 'power1',
                    onComplete: () => done(),
                }, 'inPosition')             
                .to(vid, 0, {opacity: 0}, 'inPosition')
                .fromTo(next, 0, {opacity: 0}, {opacity: 1}, 'inPosition')
                .to(burger, 0, {opacity: 1}, 'inPosition')
                .set(logoWrapper, {css: {'position' : 'static',}}, 'inPosition')
                .set(logoWrapper, {x: 0, y: 0}, 'inPosition')
                .set(document.getElementById('header-logo'), {'pointerEvents': 'auto'}, 'inPosition')
                ;         
            }                 
               
		}            
        
        // For testing next project animations without project single page load

        // let triggers = document.querySelectorAll('[data-nextprojectlink]');

        // triggers.forEach(function(trigger) {	
        //     trigger.addEventListener("click", function(event){
        //         event.preventDefault()
        //       });
        //     let data = trigger.dataset.nextprojectlink;
        //     let t = document.getElementById(data);
        //     pageTransNextProject(t);
        // });   
        /*
        !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        Barba page transitions won't work on elements
        injected via ajax when using the localhost:8000
        proxy (e.g. the featured-project transition on
        project archive).
        Please use the mmmultiply.local.
        !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        */
        barba.init({
            transitions: [
                {
                    /*
                    ********
                    ********
                    Featured project
                    ********
                    ********
                    */
                    name: 'featured-project',

                    custom: ({ trigger }) => trigger.dataset && trigger.dataset.featuredprojectlink,

                    async leave({current, trigger}) {                        
                        const done = this.async();
                        const target = document.getElementById(
                            trigger.dataset.featuredprojectlink
                        );
                        await disableScroll();
                        await beforePageLoad();
                        await featuredReset(target);
                        await pageTransFeaturedProject(target, done, heroSize()[0], heroSize()[1]);
                        done();                                        
                    },

                    async enter({next}) {
                        window.scrollTo(0,0);
                    },
                    
                    async after({next}) {
                        await enableScroll();
                        await onPageLoad();
                    },

                    // async on({current}) {
                    //     common();
                    // },

                },
                {
                    /*
                    ********
                    ********
                    Next project
                    ********
                    ********
                    */
                    name: 'next-project',

                    custom: ({ trigger }) => trigger.dataset && trigger.dataset.nextprojectlink,

                    async leave({current, trigger}) {
                        const done = this.async();
                        const target = document.getElementById(trigger.dataset.nextprojectlink);
                        disableScroll();
                        await beforePageLoad();
                        await pageTransNextProject(target, done, heroSize()[0], heroSize()[1]);
                        done();                      
                    },

                    async enter({next}) {
                        window.scrollTo(0,0);
                    },
                    
                    async after({next}) {
                        await enableScroll();
                        await onPageLoad();
                    },

                    // async on({current}) {
                    //     common();
                    // },

				},
				{
					/*
					********
					********
					Default
					********
					********
					*/
					name: 'default-transition',

					/*
					********
					Logo animation
					********
					*/                    
					async once({next}){
						const done = this.async();
                        const logoRect = document.querySelector('.k-header-inner .logo').getBoundingClientRect();
                        await disableScroll();
                        await defaultOncePrep();
                        await pageTransDefaultOnce(logoRect, done, next.container);
                        done();
					},
					async afterOnce({next}) {
						enableScroll();						
						onPageLoad();
					},                                        

					async leave({current}) {
                        const done = this.async();
                        await disableScroll();
                        await beforePageLoad();
                        await pageTransDefault(current.container, done);
                        done();                         
					},

					async enter({next}) {
						window.scrollTo(0,0);
					},

					async after({next}) {
						enableScroll();						
						onPageLoad();
					},                    
					// async after({next}) {
					// 	enableScroll();						
					// 	onPageLoad();
					// },

					// async on({current}) {
					// 	common.containerInit();
					// },

				},                
            ]
        });

    },
};

export default pageTransitions;